import { EndpointPredefinedMessageLinkModel } from "../schema/endpoint-predefined-message-link.model";
import { MongoBaseContainer } from "./mongo-base-container.model";

export class EndpointPredefinedMessageLinkContainer extends MongoBaseContainer{
    endpoint_predefined_message_link: EndpointPredefinedMessageLinkModel
}